module.exports = __webpack_public_path__ + "static/media/train5.3afbe0d0.png";